import { useEffect, useState } from 'react';

import { useTracking } from 'hooks/analytic-tracking';
import { useToast } from 'hooks/toast';
import { useSelector } from 'react-redux';

import { RoleConfig } from './components/RoleConfig/RoleConfig';
import { List } from 'components/List/List';

import { useGetPermissionsQuery } from 'api/permissions-api';
import { selectUser } from 'api/user-slice';

export const RolesTab = ({
  users,
  roles,
  updateRole = () => {},
  deleteRole = () => {},
  createRole = () => {},
  setLoading = () => {},
}) => {
  const { data: permissions, isLoading: loadingPermissions } = useGetPermissionsQuery();

  const [role, setRole] = useState();
  const user = useSelector(selectUser);
  const showToast = useToast();

  useEffect(() => {
    setLoading(loadingPermissions);
  }, [loadingPermissions]);

  const onCreateRole = async () => {
    setLoading(true);
    const { payload: newRole } = await createRole({ name: 'New Role' });
    setRole(newRole);
    setLoading(false);
  };

  const onUpdateRole = async (id, data) => {
    setLoading(true);
    const result = await updateRole(id, data);
    if (result.error) {
      showToast(
        'Cannot update role',
        result.payload?.error?.log || 'Something went wrong.',
        'error',
      );
    }
    setLoading(false);
  };

  const onDeleteRole = async id => {
    setLoading(true);
    const result = await deleteRole(id);
    if (result.error) {
      showToast(
        'Cannot delete role',
        result.payload?.error?.log || 'Something went wrong.',
        'error',
      );
    } else {
      setRole();
    }
    setLoading(false);
  };

  return (
    <div className="d-flex">
      <List
        title="Roles"
        subtitle="Create roles and assign permissions."
        className="u-margin-right--large"
        onNew={onCreateRole}>
        <List.Category title="Roles">
          {roles.map(role => (
            <List.Item key={role.id} title={role.name} value={role} onClick={setRole} />
          ))}
        </List.Category>
      </List>
      {role && (
        <RoleConfig
          role={role}
          users={users}
          permissions={permissions}
          onClose={() => setRole(null)}
          onDelete={onDeleteRole}
          onUpdate={onUpdateRole}
        />
      )}
    </div>
  );
};
